import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { WegoAdminModel } from '../models/wegoadmin.model';
import { WegoAdminService } from '../models/wegoadmin.service';

@Component({
  selector: 'wego-add-wegoadmin-popup',
  template: require('../views/add-wegoadmin-popup.component.html'),
})

export class AddWegoAdminPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  personList: PersonModel[];
  // message: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  public personHashId: string;
  
  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('wegoAdminModal') public wegoAdminModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private wegoAdminService: WegoAdminService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.module = this.translate.instant('LblWegoAdmin');
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
  }

  ngOnChanges(change: any) {
    console.log(change);
  }
  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetPersonList();
    this.wegoAdminModal.show();
  }

  public hide(): void {
    this.wegoAdminModal.hide();
  }

  private GetPersonList() {
    this.isLoading = true;
    this.wegoAdminService.GetPersonList(this.DataListModel)
      .subscribe(
      res => {
        this.personList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(personMasterHashId: string): void {
    this.isLoading = true;
    this.wegoAdminService.AddWegoAdmin(personMasterHashId)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module])
        this.OnSuccessSelect();
        this.isLoading = false;
        //this.wegoAdminModal.hide();
        //this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.wegoAdminModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetPersonList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetPersonList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetPersonList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetPersonList();
  }
  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg })
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/wegoadminlist/components/add-wegoadmin-popup.component.ts